import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatepickerChangeService } from '../services/datepicker-change.service';

@Directive({
  selector: '[appDatepickerChange]'
})
export class DatepickerChangeDirective {

  constructor(
    private elementRef: ElementRef<HTMLInputElement>, // ✅ inject here
    private dateChangeService: DatepickerChangeService
  ) {}

  @HostListener('dateChange', ['$event'])
  onDateChange(event: MatDatepickerInputEvent<Date>) {
    const id = this.elementRef.nativeElement.id; // ✅ Now it will work
    this.dateChangeService.emitChange(event.value, id);
  }
}
